<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Orçamentos de Negócios</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Lista de Orçamentos de Negócios</h1>
      </el-col>
    </el-row>
    <el-row v-if="permissao.novo_painel" type="flex" justify="left">
      <el-col :xs="24" :sm="24" :md="20" :lg="2" :xl="1">
        <h1>
          <router-link to="/orcamentos/pesquisar" v-if="this.permissao.novo_painel">
            <el-button type="primary" icon="el-icon-circle-plus-outline">Novo</el-button>
          </router-link>
        </h1>
        <router-view />
      </el-col>
<!-- 
      <el-col :xs="24" :sm="24" :md="20" :lg="22" :xl="23">
        <el-form :inline="true" :model="formPesquisa" class="form-inline-pesquisa">
           <el-form-item label="">
            <el-input v-model="formPesquisa.pesquisa" placeholder="Pesquisa por...">
                  <el-button slot="append" @click="onSubmitPesquisa" icon="el-icon-search"></el-button>            
            </el-input>
          </el-form-item> 
        </el-form>
      </el-col>
-->
    </el-row>
    <el-row type="flex" justify="center">
      <el-table 
        :data="negocios" 
        class="main-table" 
        style="width: 98%" 
        row-key="negocio_numero"
        :expand-row-keys="expandedRows"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- NIVEL 2: Tabela de VERSÕES -->
            <el-table
              class="second-table"
              v-if="props.row.versao_revisao && props.row.versao_revisao.length"
              :data="props.row.versao_revisao"
              width="70%"
              row-key="chave_unica"
              :expand-row-keys="expandedVersions[props.row.negocio_numero] || []"
            >
              <el-table-column type="expand">
                <template slot-scope="versionProps">
                  <!-- NIVEL 3: Tabela de DIVISÕES -->
                  <el-table
                    class="third-table"
                    :data="versionProps.row.versao_revisao_divisao"
                    style="margin-left: 50px; margin-right: 20px; width:95%"
                  >
                    <!-- Colunas da DIVISÃO -->
                    <el-table-column prop="negocio_divisao" label="Divisão" width="70">
                      <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="getDivisaoIntranetTooltip(scope.row)"
                            placement="top"
                        >
                          <span>{{ scope.row.negocio_divisao }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="negocio_atividade" label="Atividade" width="85">
                      <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="getAtividadeIntranetTooltip(scope.row)"
                            placement="top"
                        >
                          <span>{{ scope.row.negocio_atividade}}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="negocio_sequencia" label="Sequência" width="95"></el-table-column>
                    <el-table-column prop="titulo" label="Título" min-width="200"></el-table-column>
                    <el-table-column prop="valor_total" label="Total Atividade" width="130" align="right"></el-table-column>
                    <el-table-column prop="geracao" label="Geração" width="95"></el-table-column>
                    <el-table-column prop="valorizacao" label="Valorização" width="190"></el-table-column>
                    <el-table-column ></el-table-column>
                    <el-table-column label="Ações" width="130" align="right">
                      <template slot-scope="scope">
                        <el-tooltip v-if="permissao.gerencial_painel" class="item" effect="light" content="Excluir a Atividade da Divisão da Revisão do Orçamento do Negócio" placement="top">
                          <el-button
                            class="details-icon-button"
                            size="mini"
                            type="danger"
                            icon="el-icon-delete"
                            @click="excluirNegocioOrcamentoRevisaoDivisao(scope.row)">
                          </el-button>
                        </el-tooltip>
                        <el-tooltip v-if="permissao.gerencial_painel" class="item" effect="light" content="Visão Gerencial da Atividade da Divisão do Orçamento do Negócio" placement="top">
                          <el-button
                            class="details-icon-button"
                            size="mini"
                            type="warning"
                            icon="el-icon-setting"
                            @click="vaiNegocioOrcamentoDivisaoGerencial(scope.row)">
                          </el-button>
                        </el-tooltip>
                        <el-tooltip v-if="permissao.ler_painel" class="item" effect="light" content="Editar a Atividade da Divisão do Orçamento do Negócio" placement="top">
                          <el-button
                            class="details-icon-button"
                            size="mini"
                            type="primary"
                            icon="el-icon-edit"
                            @click="vaiNegocioOrcamentoDivisao(scope.row)">
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- <div v-else style="margin-left: 75px; padding: 10px; color: #909399">
                    Nenhuma divisão encontrada para esta versão.
                  </div> -->
                </template>
              </el-table-column>
              
              <!-- Colunas da VERSÃO -->
              <el-table-column class="fundo-principal" prop="negocio_versao" label="Versão" width="70"></el-table-column>
              <el-table-column class="fundo-principal" prop="negocio_revisao" label="Revisão" width="75"></el-table-column>
              <el-table-column class="fundo-principal" prop="nome" label="Histórico da Revisão" min-width="300"></el-table-column>
              <el-table-column class="fundo-principal" prop="valor_total" label="Total Revisão" width="130" align="right"></el-table-column>
              <el-table-column class="fundo-principal" prop="fechamento" label="Fechamento" width="105"></el-table-column>
              <el-table-column class="fundo-principal" prop="simulacao" label="Simulado" width="85"></el-table-column>
              <el-table-column class="fundo-principal" prop="consolidado" label="Consolidado" width="105"></el-table-column>
              <el-table-column class="fundo-principal" ></el-table-column>
              <el-table-column
                label="Ações"
                width="180"
                align="right">
                <template slot-scope="scope">
                  <el-tooltip v-if="permissao.gerencial_painel" class="item" effect="light" content="Excluir Revisão do Orçamento do Negócio" placement="top">
                    <el-button
                      class="details-icon-button"
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="excluirNegocioOrcamentoRevisao(scope.row)">
                    </el-button>
                  </el-tooltip>
                  <el-tooltip v-if="permissao.gerencial_painel" class="item" effect="light" content="Itens de Todas as Atividades da Revisão" placement="top">
                    <el-button
                      class="details-icon-button"
                      size="mini"
                      type="info"
                      icon="el-icon-discount"
                      @click="gerenciarFatorItensRevisao(scope.row)">
                    </el-button>
                  </el-tooltip>
                  <el-tooltip v-if="permissao.editar_painel" class="item" effect="light" content="Criar uma nova Revisão baseada na Revisão atual do Orçamento do Negócio" placement="top">
                    <el-button
                      class="details-icon-button"
                      size="mini"
                      type="warning"
                      icon="el-icon-document-copy"
                      @click="criarNovaRevisaoOrcamento(scope.row)">
                    </el-button>
                  </el-tooltip>
                  <el-tooltip v-if="permissao.editar_painel" class="item" effect="light" content="Editar dados da Revisão do Orçamento Negócio" placement="top">
                    <el-button
                      class="details-icon-button"
                      size="mini"
                      type="primary"
                      icon="el-icon-edit"
                      @click="formNegocioOrcamentoRevisaoShow(scope.row)">
                    </el-button>
                  </el-tooltip>
                  <el-tooltip v-if="permissao.imprimir_painel" class="item" effect="light" content="Imprimir Revisão do Orçamento do Negócio" placement="top">
                    <el-button
                      class="details-icon-button"
                      size="mini"
                      type="success"
                      icon="el-icon-printer"
                      @click="imprimirOrcamentoNegocioPDF(scope.row)">
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <div v-else style="margin-left: 50px; padding: 10px; color: #909399">
              Nenhuma versão encontrada para este negócio.
            </div>
          </template>
        </el-table-column>
        
        <!-- Colunas do NEGÓCIO (NÍVEL 1) -->
        <el-table-column class="fundo-principal" prop="negocio_numero" label="Negócio" width="80"></el-table-column>
        <el-table-column class="fundo-principal" prop="negocio_cliente.razao_social" label="Cliente" min-width="200"></el-table-column>
        <el-table-column class="fundo-principal" prop="negocio_cliente.municipio" label="Município" width="120"></el-table-column>
        <el-table-column class="fundo-principal" prop="negocio_cliente.uf" label="UF" width="40"></el-table-column>
        <el-table-column class="fundo-principal" prop="negocio_cliente.pais" label="País" width="50"></el-table-column>
        <el-table-column
          label="Ações"
          width="80"
          align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="permissao.gerencial_painel" class="item" effect="light" content="Excluir Orçamento Negócio" placement="top">
              <el-button
                class="details-icon-button"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="excluirNegocioOrcamento(scope.row)">
              </el-button>
            </el-tooltip>
<!-- 
            <el-tooltip v-if="permissao.editar_painel" class="item" effect="light" content="Editar dados do Orçamento do Negócio" placement="top">
              <el-button
                class="details-icon-button"
                size="mini"
                type="primary"
                icon="el-icon-edit"
                @click="formNegocioOrcamentoShow(scope.row)">
              </el-button>
            </el-tooltip>
-->
          </template>

        </el-table-column>

      </el-table>
    </el-row>
<!-- 
    <el-row>
      <el-col :span="24">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          background
          :total="total"
        ></el-pagination>
      </el-col>
    </el-row>
-->

    <el-dialog
      title="Detalhes do Orçamento do Negócio"
      :visible.sync="formNegocioOrcamentoVisivel"
      width="1000px"
      :close-on-click-modal="false"
      :before-close="formNegocioOrcamentoClose">
      
      <el-form 
        ref="formNegocioOrcamento" 
        :model="selectedRow" 
        label-width="125px" 
        size="small">

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Negócio" style="text-align: left">
              <span><strong>{{ selectedRow.negocio }} </strong></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Cliente" style="text-align: left">
              <span><strong>{{ selectedRow.razao_social }} </strong></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Município" style="text-align: left">
              <span><strong>{{ selectedRow.municipio }} </strong></span> - <span><strong>{{ selectedRow.uf }} </strong></span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="formNegocioOrcamentoClose">Cancelar</el-button>
        <el-button type="primary" @click="salvarNegocioOrcamento(selectedRow)">Salvar Alteração</el-button>
      </span>
    </el-dialog>


    <el-dialog
      title="Detalhes da Revisão do Orçamento do Negócio"
      :visible.sync="formNegocioOrcamentoRevisaoVisivel"
      width="1000px"
      :close-on-click-modal="false"
      :before-close="formNegocioOrcamentoRevisaoClose">
      
      <el-form 
        ref="formNegocioOrcamentoRevisao" 
        :model="selectedRow" 
        label-width="125px" 
        size="small">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Negócio" style="text-align: left">
              <span><strong>{{ selectedRow.negocio_numero }} </strong></span> - Versão: <span><strong>{{ selectedRow.negocio_versao }} </strong></span> - Revisão: <span><strong>{{ selectedRow.negocio_revisao }} </strong></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Histórico" style="text-align: left">
              <span><strong>{{ selectedRow.negocio_nome }} </strong></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Valor" style="text-align: left">
              <span><strong>{{ selectedRow.negocio_valor }} </strong></span> 
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <p style="text-align: left"><strong>Contato Cliente</strong></p>
            <el-form-item label="Nome" prop="cliente_contato_nome">
              <el-input
                v-model="selectedRow.cliente_contato_nome"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <p style="text-align: left"><strong>Contato Representante</strong></p>
            <el-form-item label="Nome" prop="empresa_representante_nome">
              <el-input
                v-model="selectedRow.empresa_representante_nome"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Cargo" prop="cliente_contato_cargo">
              <el-input
                v-model="selectedRow.cliente_contato_cargo"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <el-form-item label="Email" prop="empresa_representante_email">
              <el-input
                v-model="selectedRow.empresa_representante_email"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Email" prop="cliente_contato_email">
              <el-input
                v-model="selectedRow.cliente_contato_email"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <el-form-item label="Telefone" prop="empresa_representante_telefone">
              <el-input
                v-model="selectedRow.empresa_representante_telefone"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Telefone" prop="cliente_contato_telefone">
              <el-input
                v-model="selectedRow.cliente_contato_telefone"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <p style="text-align: left"><strong>Contato Engenharia</strong></p>
            <el-form-item label="Nome" prop="empresa_engenharia_nome">
              <el-input
                v-model="selectedRow.empresa_engenharia_nome"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <p style="text-align: left"><strong>Responsável Empresa</strong></p>
            <el-form-item label="Nome" prop="empresa_aceite_nome">
              <el-input
                v-model="selectedRow.empresa_aceite_nome"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Email" prop="empresa_engenharia_email">
              <el-input
                v-model="selectedRow.empresa_engenharia_email"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <el-form-item label="Cargo" prop="empresa_aceite_cargo">
              <el-input
                v-model="selectedRow.empresa_aceite_cargo"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Telefone" prop="empresa_engenharia_telefone">
              <el-input
                v-model="selectedRow.empresa_engenharia_telefone"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <el-form-item label="Email" prop="empresa_aceite_email">
              <el-input
                v-model="selectedRow.empresa_aceite_email"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <br />
          </el-col>  
          <el-col :span="12">
            <el-form-item label="Telefone" prop="empresa_aceite_telefone">
              <el-input
                v-model="selectedRow.empresa_aceite_telefone"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <p style="text-align: left"><strong>Dados do Frete</strong></p>
            <el-form-item label="Tipo" prop="frete_tipo">
              <el-select 
                v-model="selectedRow.frete_tipo" 
                placeholder="Selecione"
                style="width: 100%"
              >
                <el-option label="CIF" value="CIF" />
                <el-option label="FOB" value="FOB" />
              </el-select>
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <p style="text-align: left"><strong>Outros Dados</strong></p>
            <el-form-item label="Pagamento" prop="condicoes_pagamento">
              <el-input
                v-model="selectedRow.condicoes_pagamento"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Empresa" prop="frete_empresa">
              <el-input
                v-model="selectedRow.frete_empresa"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <el-form-item label="Garantia" prop="periodo_garantia">
              <el-input
                v-model="selectedRow.periodo_garantia"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Cidade" prop="frete_local_cidade">
              <el-input
                v-model="selectedRow.frete_local_cidade"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <el-form-item label="Validade" prop="proposta_validade">
              <el-input
                v-model="selectedRow.proposta_validade"
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Estado" prop="frete_local_uf">
              <el-select 
                v-model="selectedRow.frete_local_uf" 
                placeholder="Selecione"
                filterable
                style="width: 100%"
              >
                <el-option label="Acre (AC)" value="AC" />
                <el-option label="Alagoas (AL)" value="AL" />
                <el-option label="Amapá (AP)" value="AP" />
                <el-option label="Amazonas (AM)" value="AM" />
                <el-option label="Bahia (BA)" value="BA" />
                <el-option label="Ceará (CE)" value="CE" />
                <el-option label="Distrito Federal (DF)" value="DF" />
                <el-option label="Espírito Santo (ES)" value="ES" />
                <el-option label="Goiás (GO)" value="GO" />
                <el-option label="Maranhão (MA)" value="MA" />
                <el-option label="Mato Grosso (MT)" value="MT" />
                <el-option label="Mato Grosso do Sul (MS)" value="MS" />
                <el-option label="Minas Gerais (MG)" value="MG" />
                <el-option label="Pará (PA)" value="PA" />
                <el-option label="Paraíba (PB)" value="PB" />
                <el-option label="Paraná (PR)" value="PR" />
                <el-option label="Pernambuco (PE)" value="PE" />
                <el-option label="Piauí (PI)" value="PI" />
                <el-option label="Rio de Janeiro (RJ)" value="RJ" />
                <el-option label="Rio Grande do Norte (RN)" value="RN" />
                <el-option label="Rio Grande do Sul (RS)" value="RS" />
                <el-option label="Rondônia (RO)" value="RO" />
                <el-option label="Roraima (RR)" value="RR" />
                <el-option label="Santa Catarina (SC)" value="SC" />
                <el-option label="São Paulo (SP)" value="SP" />
                <el-option label="Sergipe (SE)" value="SE" />
                <el-option label="Tocantins (TO)" value="TO" />
              </el-select>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <p style="text-align: left"><strong>Status</strong></p>
            <el-form-item label="Fabricante no RS" prop="fabricante_rs">
              <el-select 
                v-model="selectedRow.fabricante_rs" 
                placeholder="Selecione"
                disabled
                style="width: 100%"
              >
                <el-option label="Sim" value="S" />
                <el-option label="Não" value="N" />
              </el-select>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Simulação" prop="simulacao">
              <el-select 
                v-model="selectedRow.simulacao" 
                placeholder="Selecione"
                style="width: 100%"
              >
                <el-option label="Sim" value="S" />
                <el-option label="Não" value="N" />
              </el-select>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Consolidado" prop="consolidado">
              <el-select 
                v-model="selectedRow.consolidado" 
                placeholder="Selecione"
                :disabled="selectedRow.consolidado === 'S'"
                style="width: 100%"
              >
                <el-option label="Sim" value="S" />
                <el-option label="Não" value="N" />
              </el-select>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Fechamento" prop="fechamento">
              <el-input
                v-model="selectedRow.fechamento"
                disabled
                style="width: 100%">
              </el-input>
            </el-form-item>
          </el-col>  
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Observação" prop="observacao_externa">
              <el-input
                type="textarea"
                v-model="selectedRow.observacao_externa"
                placeholder="Digite as observações que serão apresentadas ao cliente aqui..."
                :rows="4"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>  
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formNegocioOrcamentoRevisaoClose">Cancelar</el-button>
        <el-button type="primary" @click="salvarNegocioOrcamentoRevisao(selectedRow)">Salvar Alteração</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      loading: true,
      negocios: [],
      expandedRows: [],
      expandedVersions: {},

      total: 0,
      pageSize: 12,
      listLoading: false,
      currentPage: 1,

      itens: [],
      permissao: {},
      labelPosition: "right",
      dialogFormVisibleEdit: false,
      formNegocioOrcamentoVisivel: false,
      formNegocioOrcamentoRevisaoVisivel: false,
      selectedRow: {},
      negocio_detalhe: {},
      negocio_revisao_detalhe: {},
      formPesquisa: {
        pesquisa: "",
      },
      ruleFormEdit: {
        nome: "",
        email: "",
        id: "",
      },
      rules: {
        nome: [
          {
            required: true,
            message: "Por Favor, informe o Nome",
            trigger: "blur",
          },
          {
            min: 3,
            message: "Deve ter pelo menos 3 caracteres",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "Informe o e-mail.", trigger: "blur" },
          {
            type: "email",
            message: "Informe um e-mail válido.",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    tableDataNegocios() {
      this.pesquisaX123();
      return this.negocios;
    }
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    // console.log("Permissão do Usuário:", this.permissao);
    if (!this.permissao.ler_painel) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.loading = true;
    axios
      .get(url + "/orclist/", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.total = response.data.length;
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });

    axios
      .get(url + "/orclist/0/" + this.pageSize, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        this.itens = response.data;
        this.loading = false;
      })
      .catch((err) => {
        this.itens = "erro" + err;
      });
      this.pesquisaX123();

  },
  methods: {
    //PESQUISA
    onSubmitPesquisa() {
      this.loading = true;
      let dados = {
        pesquisa: this.formPesquisa.pesquisa,
      };
      axios
        .post(url + "/userssearch/0/" + this.pageSize, dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.itens = response.data.dados;
          this.loading = false;
          this.total = response.data.total;
          this.currentPage = 1;
        })
        .catch((err) => {
          this.itens = "erro" + err;
        });
    },
    //FIM PESQUISA
    //PAGINAÇÃO
    handleSizeChange: function (size) {
      this.pageSize = size;
      let comeca_em;
      if (this.currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (this.currentPage - 1) * this.pageSize;
      }
      this.getDados(comeca_em, this.pageSize);
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      let comeca_em;
      if (currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (currentPage - 1) * this.pageSize;
      }
      this.getDados(comeca_em, this.pageSize);
    },

    //FIM PAGINAÇÃO
    //LISTAR DADOS
    getDados(paginaCorrente = 0, TamanhoPagina = "") {
      if (this.formPesquisa.pesquisa != "") {
        let dados = {
          pesquisa: this.formPesquisa.pesquisa,
        };
        axios
          .post(
            url + "/orcsearch/" + paginaCorrente + "/" + this.pageSize,
            dados,
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.itens = response.data.dados;
            this.total = response.data.total;
            this.currentPage = paginaCorrente;
          })
          .catch((err) => {
            this.itens = "erro" + err;
          });
      } else {
        if (!TamanhoPagina) {
          TamanhoPagina = this.pageSize;
        }
        axios
          .get(url + "/orclist/" + paginaCorrente + "/" + TamanhoPagina, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.itens = response.data;
          })
          .catch((err) => {
            this.itens = "erro" + err;
          });
      }
    },
    
    //FIM LISTAR DADOS
    //EDITAR
    handleEdit(index, row) {
      //this.$router.push({ name: "editOrcamento", params: { id: row.id } });
      this.$router.push({ name: "cadNovaVersao", params: { id: row.id } });
    },
    //FIM EDITAR
    //VISUALIZAR
    handleVisualizar(index, row) {
      this.$router.push({ name: "visOrcamento", params: { id: row.id } });
    },
    //FIM VISUALIZAR

    //GERAR PROPOSTA
    handleProposta(index, row) {
      this.$router.push({ name: "gerarProposta", params: { id: row.id } });
    },
    //FIM VISUALIZAR    

    //EXCLUIR
    handleDelete(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/orcamentos/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDados();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    //FIM EXCLUIR


    async imprimirOrcamentoNegocioPDF(row) {
      
      // console.log('Orçamento Negócio:', JSON.stringify(row, null, 2));
      // console.log('ID do Orçamento Negócio Revisão:', row.id);

      try {

        this.loading = true;

        const dados = {
          id: row.id,
        };

        // console.log("Dados enviados:", dados);      

        const response = await axios.post(url+'/orcamento/divisao/negocio/imprimir-pdf', dados, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
            responseType: 'blob',
          }
        );
        
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const numeroOrcamento = row.negocio_numero+'-'+row.negocio_versao+'-'+row.negocio_revisao;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Orcamento_Negocio_${numeroOrcamento}.pdf`;
        link.click();
        this.$message.success('Relatório PDF gerado com sucesso!');
      } catch (error) {
        this.$message.error('Erro ao gerar o PDF do Orçamento do Negócio: ' + (error.response?.data?.message || error.message));
      } finally {
        this.loading = false;
      }

    },


    vaiNegocioOrcamentoDivisao(row) {
      this.$router.push({ name: "NegocioOrcamentosDivisao", params: { id: row.id } });
    },
    vaiNegocioOrcamentoDivisaoGerencial(row) {
      this.$router.push({ name: "NegocioOrcamentosDivisaoGerencial", params: { id: row.id } });
    },
    async gerenciarFatorItensRevisao(row) {
      // console.log('gerenciarFatorItensRevisao', row)
      this.$router.push({ name: "NegocioOrcamentosRevisaoFator", params: { id: row.id } });
    },
    async excluirNegocioOrcamentoRevisaoDivisao(row) {
      this.$confirm(
        "Tem certeza que deseja <strong>excluir</strong> esta Atividade da Divisão da Revisão do Negócio?",
        "Atenção - Exclusão Irreversível",
        {
          confirmButtonText: "Sim, excluir",
          cancelButtonText: "Não, cancelar",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          // Segunda confirmação (mais explícita)
          const segundaConfirmacao = await this.$confirm(
            "Esta ação <b>não poderá ser desfeita</b>.<br/><br/>Deseja realmente excluir o registro permanentemente?",
            "Confirmação Final",
            {
              confirmButtonText: "Excluir definitivamente",
              cancelButtonText: "Cancelar",
              type: "error",
              dangerouslyUseHTMLString: true,
              distinguishCancelAndClose: true,
            }
          ).catch(() => false);
          if (!segundaConfirmacao) return; // usuário cancelou na 2ª pergunta
          try {
            this.loading = true;
            const id = row.id;
            // console.log("ID da Divisão da Revisão do Negócio:", id);
            const response = await axios.get(url + "/negocio-revisao-divisao-excluir/"+id,
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              }
            );
            if (response.status === 401) {
              await this.$store.dispatch("logout");
              this.$router.push("/login");
              return;
            }
            this.$notify({
              title: "Sucesso",
              message: "Divisão da revisão excluída com sucesso.",
              type: "success",
            });
            // Opcional: atualizar a lista / remover linha da tabela
            // this.tabela = this.tabela.filter(item => item.id !== id)
            // ou chamar método que recarrega os dados
          } catch (error) {
            let mensagemErro = "Falha ao excluir o registro";
            if (error.response?.data?.message) {
              mensagemErro = error.response.data.message;
            } else if (error.message) {
              mensagemErro = error.message;
            }
            this.$notify({
              title: "Erro",
              message: mensagemErro,
              type: "error",
              duration: 6000,
            });
          } finally {
            this.loading = false;
          }
        })
        .catch(() => {
          // usuário cancelou a primeira confirmação
          this.$notify({
            title: "Info",
            message: "Exclusão cancelada!",
            type: "info",
          });
        });
    },
    async excluirNegocioOrcamentoRevisao(row){
      this.$confirm(
        "Tem certeza que deseja <strong>excluir</strong> esta Revisão do Negócio?",
        "Atenção - Exclusão Irreversível",
        {
          confirmButtonText: "Sim, excluir",
          cancelButtonText: "Não, cancelar",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          // Segunda confirmação (mais explícita)
          const segundaConfirmacao = await this.$confirm(
            "Esta ação <b>não poderá ser desfeita</b>.<br/><br/>Deseja realmente excluir o registro permanentemente?",
            "Confirmação Final",
            {
              confirmButtonText: "Excluir definitivamente",
              cancelButtonText: "Cancelar",
              type: "error",
              dangerouslyUseHTMLString: true,
              distinguishCancelAndClose: true,
            }
          ).catch(() => false);
          if (!segundaConfirmacao) return; // usuário cancelou na 2ª pergunta
          try {
            this.loading = true;
            const id = row.id;
            // console.log("ID da Revisão do Negócio:", id);
            const response = await axios.get(url + "/negocio-revisao-excluir/"+id,
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              }
            );
            if (response.status === 401) {
              await this.$store.dispatch("logout");
              this.$router.push("/login");
              return;
            }
            this.$notify({
              title: "Sucesso",
              message: "Revisão excluída com sucesso.",
              type: "success",
            });
            // Opcional: atualizar a lista / remover linha da tabela
            // this.tabela = this.tabela.filter(item => item.id !== id)
            // ou chamar método que recarrega os dados
          } catch (error) {
            let mensagemErro = "Falha ao excluir o registro";

            if (error.response?.data?.message) {
              mensagemErro = error.response.data.message;
            } else if (error.message) {
              mensagemErro = error.message;
            }
            this.$notify({
              title: "Erro",
              message: mensagemErro,
              type: "error",
              duration: 6000,
            });
          } finally {
            this.loading = false;
          }
        })
        .catch(() => {
          // usuário cancelou a primeira confirmação
          this.$notify({
            title: "Info",
            message: "Exclusão cancelada!",
            type: "info",
          });
        });
    },
    async excluirNegocioOrcamento(row){
      this.$confirm(
        "Tem certeza que deseja <strong>excluir</strong> este Negócio?",
        "Atenção - Exclusão Irreversível",
        {
          confirmButtonText: "Sim, excluir",
          cancelButtonText: "Não, cancelar",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          // Segunda confirmação (mais explícita)
          const segundaConfirmacao = await this.$confirm(
            "Esta ação <b>não poderá ser desfeita</b>.<br/><br/>Deseja realmente excluir o registro permanentemente?",
            "Confirmação Final",
            {
              confirmButtonText: "Excluir definitivamente",
              cancelButtonText: "Cancelar",
              type: "error",
              dangerouslyUseHTMLString: true,
              distinguishCancelAndClose: true,
            }
          ).catch(() => false);
          if (!segundaConfirmacao) return; // usuário cancelou na 2ª pergunta
          try {
            this.loading = true;
            const negocio_numero = row.negocio_numero;
            // console.log("ID do Negócio:", negocio_numero);
            const response = await axios.get(url + "/negocio-excluir/"+negocio_numero,
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              }
            );
            if (response.status === 401) {
              await this.$store.dispatch("logout");
              this.$router.push("/login");
              return;
            }
            this.$notify({
              title: "Sucesso",
              message: "Negócio excluído com sucesso.",
              type: "success",
            });
            // Atualizar a lista
            // this.pesquisaX123();
          } catch (error) {
            let mensagemErro = "Falha ao excluir o registro";
            if (error.response?.data?.message) {
              mensagemErro = error.response.data.message;
            } else if (error.message) {
              mensagemErro = error.message;
            }
            this.$notify({
              title: "Erro",
              message: mensagemErro,
              type: "error",
              duration: 6000,
            });
          } finally {
            this.loading = false;
          }
        })
        .catch(() => {
          // usuário cancelou a primeira confirmação
          this.$notify({
            title: "Info",
            message: "Exclusão cancelada!",
            type: "info",
          });
        });
    },
    getDivisaoIntranetTooltip(row) {
      return (row.negocio_divisao_descricao || '—');
    },
    getAtividadeIntranetTooltip(row) {
      return (row.negocio_atividade_descricao || '—');
    },
    showDetailsDivisao(row) {
      this.$alert(
        `Divisão: ${row.negocio_divisao}\n` +
        `Total: ${row.valor_total}\n` +
        `Atividades: ${row.atividades ? row.atividades.length : 0}`, 
        'Detalhes da Divisão', {
        confirmButtonText: 'OK'
      });
    },
    showDetailsVersao(row) {
      this.$alert(
        `Versão: ${row.negocio_versao} Revisão: ${row.negocio_revisao}\n` +
        `Total: ${row.valor_total}\n` +
        `Divisões: ${row.divisao ? row.divisao.length : 0}`, 
        'Detalhes da Versão', {
        confirmButtonText: 'OK'
      });
    },
    showDetailsNegocio(row) {
      this.$alert(
        `Negócio: ${row.negocio_numero}\n` +
        `Cliente: ${row.negocio_cliente.razao_social}\n` +
        `Total: ${row.negocio_cliente.total}\n` +
        `Versões: ${row.versao_revisao ? row.versao_revisao.length : 0}`, 
        'Detalhes do Negócio', {
        confirmButtonText: 'OK'
      });
    },

    criarNovaRevisaoOrcamento(row){
      console.log("Criar nova revisão para o orçamento do negócio:", row);
      alert("Funcionalidade de criar nova revisão ainda não implementada.");
      // this.$router.push({ name: "cadNovaVersao", params: { id: row.id } });
    },

    async formNegocioOrcamentoShow(row) {

      try {

        this.loading = true;

        const negocioId = row.negocio_numero;

        // console.log("Negócio ID para pesquisa #322:", negocioId);

        const response = await axios.get(url + "/negocio-orcamento-detalhe/"+negocioId, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }
        this.negocio_detalhe = response.data;
        // console.log("Negocio Detalhe:", this.negocio_detalhe);
        this.$notify({
          title: "Sucesso",
          message: "Pesquisa realizada com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          title: "Erro",
          message: `Falha ao realizar a pesquisa: ${error.message}`,
          type: "error",
        });
      } finally {
        this.loading = false;
      }

      this.selectedRow = {
        id: this.negocio_detalhe.id,
        negocio: row.negocio_numero,
        razao_social: row.negocio_cliente.razao_social,
        municipio: row.negocio_cliente.municipio,
        uf: row.negocio_cliente.uf,
      };

      // console.log("Selected Row para edição:", this.selectedRow);
      this.formNegocioOrcamentoVisivel = true;
    },

    formNegocioOrcamentoClose() {
      this.formNegocioOrcamentoVisivel = false;
      this.selectedRow = {};
    },

    async formNegocioOrcamentoRevisaoShow(row) {

      try {

        this.loading = true;

        const negocioRevisaoId = row.id;

        // console.log("Negócio ID para pesquisa #321:", negocioRevisaoId);

        const response = await axios.get(url + "/negocio-orcamento-revisao-detalhe/"+negocioRevisaoId, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }
        this.negocio_revisao_detalhe = response.data;

        // console.log("Negocio Revisão Detalhe:", this.negocio_revisao_detalhe);

        this.$notify({
          title: "Sucesso",
          message: "Pesquisa realizada com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          title: "Erro",
          message: `Falha ao realizar a pesquisa: ${error.message}`,
          type: "error",
        });
      } finally {
        this.loading = false;
      }

      // console.log("Linha recebida para revisão:", row);

      this.selectedRow = {
        id: row.id,
        negocio_numero: row.negocio_numero,
        negocio_versao: row.negocio_versao,
        negocio_revisao: row.negocio_revisao,
        negocio_nome: row.nome,
        negocio_valor: row.valor_total,
        negocio_fechamento: row.fechamento,
        // razao_social: row.negocio_cliente.razao_social,
        // municipio: row.negocio_cliente.municipio,
        // uf: row.negocio_cliente.uf,
        cliente_contato_nome: this.negocio_revisao_detalhe.cliente_contato_nome,
        cliente_contato_cargo: this.negocio_revisao_detalhe.cliente_contato_cargo,
        cliente_contato_email: this.negocio_revisao_detalhe.cliente_contato_email,
        cliente_contato_telefone: this.negocio_revisao_detalhe.cliente_contato_telefone,
        empresa_representante_nome: this.negocio_revisao_detalhe.empresa_representante_nome,
        empresa_representante_email: this.negocio_revisao_detalhe.empresa_representante_email,
        empresa_representante_telefone: this.negocio_revisao_detalhe.empresa_representante_telefone,
        empresa_engenharia_nome: this.negocio_revisao_detalhe.empresa_engenharia_nome,
        empresa_engenharia_email: this.negocio_revisao_detalhe.empresa_engenharia_email,
        empresa_engenharia_telefone: this.negocio_revisao_detalhe.empresa_engenharia_telefone,
        empresa_aceite_nome: this.negocio_revisao_detalhe.empresa_aceite_nome,
        empresa_aceite_cargo: this.negocio_revisao_detalhe.empresa_aceite_cargo,
        empresa_aceite_email: this.negocio_revisao_detalhe.empresa_aceite_email,
        empresa_aceite_telefone: this.negocio_revisao_detalhe.empresa_aceite_telefone,
        fabricante_rs: this.negocio_revisao_detalhe.fabricante_rs,
        frete_tipo: this.negocio_revisao_detalhe.frete_tipo,
        frete_empresa: this.negocio_revisao_detalhe.frete_empresa,
        frete_local_cidade: this.negocio_revisao_detalhe.frete_local_cidade,
        frete_local_uf: this.negocio_revisao_detalhe.frete_local_uf,
        condicoes_pagamento: this.negocio_revisao_detalhe.condicoes_pagamento,
        periodo_garantia: this.negocio_revisao_detalhe.periodo_garantia,
        proposta_validade: this.negocio_revisao_detalhe.proposta_validade,
        observacao_externa: this.negocio_revisao_detalhe.observacao_externa,
        fechamento: this.negocio_revisao_detalhe.fechamento,
        simulacao: this.negocio_revisao_detalhe.simulacao,
        consolidado: this.negocio_revisao_detalhe.consolidado,
      };

      // console.log("Selected Row para edição:", this.selectedRow);
      this.formNegocioOrcamentoRevisaoVisivel = true;
    },
    formNegocioOrcamentoRevisaoClose() {
      this.formNegocioOrcamentoRevisaoVisivel = false;
      this.selectedRow = {};
    },

    async salvarNegocioOrcamento(selectedRow) {
      // Lógica para salvar as alterações do orçamento do negócio
      // console.log("Salvando alterações para:", selectedRow);

      try {

        this.loading = true;

        const dados = selectedRow;

        // console.log("Dados enviados:", dados);      

        const response = await axios.post(url+'/orcamento/negocio/salvar-detalhes-negocio', dados, {
            headers: { Authorization: "Bearer " + this.$store.state.token }
          }
        );
        
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        this.$message.success('Dados no Orçamento do Negócio alterado com sucesso!');

        this.$notify({
          title: "Sucesso",
          message: "Alterações salvas com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$message.error('Erro ao alterar dados do Orçamento do Negócio: ' + (error.response?.data?.message || error.message));
      } finally {
        this.loading = false;
      }

      this.formNegocioOrcamentoClose();
    },

    async salvarNegocioOrcamentoRevisao(selectedRow) {

      // Lógica para salvar as alterações do orçamento do negócio
      // console.log("Salvando alterações para:", selectedRow);

      try {

        this.loading = true;

        const dados = selectedRow;

        // console.log("Dados enviados:", dados);      

        const response = await axios.post(url+'/orcamento/negocio/salvar-detalhes-negocio-revisao', dados, {
            headers: { Authorization: "Bearer " + this.$store.state.token }
          }
        );
        
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        this.$message.success('Dados no Orçamento do Negócio alterado com sucesso!');

        this.$notify({
          title: "Sucesso",
          message: "Alterações salvas com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$message.error('Erro ao alterar dados do Orçamento do Negócio: ' + (error.response?.data?.message || error.message));
      } finally {
        this.loading = false;
      }
      this.formNegocioOrcamentoRevisaoClose();
    },
    async pesquisaX123() {
      try {
        this.loading = true;
        const response = await axios.get(url + "/negocio-orcamentos-todos/", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });
        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }
        if (!Array.isArray(response.data) && typeof response.data !== "object") {
          throw new Error("Dados recebidos não estão no formato esperado");
        }
        // console.log("X123:", response.data);
        // if (!empty(response.data.negocios)) {
        this.negocios = response.data.negocios;
        // } else {
        //   this.negocios = null;
        // }
        
        // console.log("this.negocios:", this.negocios);
        this.$notify({
          title: "Sucesso",
          message: "Pesquisa realizada com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          title: "Erro",
          message: `Falha ao realizar a pesquisa #275: ${error.message}`,
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

  }
}
</script>

<style>
    .form-inline-pesquisa {
      margin-top: 15px;
      text-align: left;
      padding-left: 50px;
    }
    .el-table {
      box-sizing: border-box;
    }
    .el-table th, .el-table td {
      padding: 0px !important       ;
    }
    .main-table .el-table__body-wrapper .el-table__row .el-table__cell {
      background-color: #f0f9eb !important; /* Verde claro - NÍVEL 1 */
    }
    .second-table .el-table__body-wrapper .el-table__row .el-table__cell {
      background-color: #fff3cd !important; /* Amarelo claro - NÍVEL 2 */
    }
    .third-table .el-table__body-wrapper .el-table__row .el-table__cell {
      background-color: #e3f2fd !important; /* Azul claro - NÍVEL 3 */
    }
    .third-table.el-table {
      margin-right: 20%;
    }
    .details-icon-button.el-button--mini {
      padding: 5px;
    }
    .el-row-topo {
      margin-top: 0px;
    }
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 0px;
    }
    .item {
      margin:0;
    }
</style>
